import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=223d042a&"
import script from "./Secondary.vue?vue&type=script&lang=js&"
export * from "./Secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223d042a')) {
      api.createRecord('223d042a', component.options)
    } else {
      api.reload('223d042a', component.options)
    }
    module.hot.accept("./Secondary.vue?vue&type=template&id=223d042a&", function () {
      api.rerender('223d042a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/Secondary.vue"
export default component.exports